/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1SerieIdMutationResponse,
  DeleteApiV1SerieIdPathParams,
  DeleteApiV1SerieId401,
  DeleteApiV1SerieId404,
  DeleteApiV1SerieId500,
} from "../../types/serieRegistroController/DeleteApiV1SerieId.ts";

function getDeleteApiV1SerieIdUrl(id: DeleteApiV1SerieIdPathParams["id"]) {
  const res = { method: "DELETE", url: `/api/v1/serie/${id}` as const };
  return res;
}

/**
 * @description Exclusão física da série e de tudo relacionado (idiomas, turmas, vídeos e idiomas dos vídeos). **(Requer Authorization para autenticação)**
 * @summary Excluir série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:id}
 */
export async function deleteApiV1SerieId(
  id: DeleteApiV1SerieIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1SerieId401 | DeleteApiV1SerieId404 | DeleteApiV1SerieId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1SerieIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
